var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMerkmalAngebot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iAngebot",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#iAngebot .cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#76b82a",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.59 9.8A2 2 0 0 0 13 9.14a2 2 0 0 0-1.57.66 2.81 2.81 0 0 0-.57 1.91 2.88 2.88 0 0 0 .57 1.94 2 2 0 0 0 1.57.66 2 2 0 0 0 1.57-.66 2.92 2.92 0 0 0 .56-1.93 2.91 2.91 0 0 0-.54-1.92Zm-.91 3.2a.71.71 0 0 1-.66.38.69.69 0 0 1-.66-.38 2.53 2.53 0 0 1-.22-1.24 2.5 2.5 0 0 1 .22-1.22.7.7 0 0 1 .66-.39.72.72 0 0 1 .66.39 2.64 2.64 0 0 1 .21 1.22 2.68 2.68 0 0 1-.21 1.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "matrix(.5 -.87 .87 .5 -3.66 13.65)",
    d: "M5.06 9.42h9.89v1.15H5.06z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.13 8.23a2.86 2.86 0 0 0-.57-1.92A2 2 0 0 0 7 5.65a2 2 0 0 0-1.57.66 2.86 2.86 0 0 0-.56 1.92 2.87 2.87 0 0 0 .56 1.93 2 2 0 0 0 1.57.66 2 2 0 0 0 1.58-.66 2.87 2.87 0 0 0 .55-1.93ZM7.65 9.47a.71.71 0 0 1-.65.38.7.7 0 0 1-.65-.38 2.68 2.68 0 0 1-.21-1.24A2.66 2.66 0 0 1 6.33 7a.75.75 0 0 1 1.31 0 2.5 2.5 0 0 1 .22 1.22 2.68 2.68 0 0 1-.21 1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerkmalAngebot);
export default __webpack_public_path__ + "static/media/icon-merkmal-angebot.bb4fb3eb4e703e603a2a0201766a70d0.svg";
export { ForwardRef as ReactComponent };